<template>
  <div class="bigbox" v-loading="loading">
    <div class="form">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="年份:">
          <el-select clearable @change="handelchange" v-model="formInline.year" placeholder="请选择" size="small"
                     style="width: 80px; margin-right: 20px">
            <el-option v-for="item in yearoptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="省|直辖市:">
          <el-select clearable @change="handelchange" v-model="formInline.province" placeholder="不限" size="small"
                     style="width: 120px; margin-right: 20px" value-key="id">
            <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="科别类型:">
          <el-select clearable @change="disciplineTypeChange" v-model="formInline.disciplineType" placeholder="不限"
                     size="small" style="width: 100px; margin-right: 20px">
            <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="录取批次：">
          <el-select clearable @change="batchChange" v-model="formInline.admitBatch" placeholder="不限" size="small"
                     style="width: 140px; margin-right: 20px">
            <el-option v-for="item in batchoptions" :key="item.batchId" :label="item.batch" :value="item.batch">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关联院校:">
          <el-select clearable v-model="formInline.hasRelateGx" placeholder="不限" size="small"
                     style="width: 80px; margin-right: 20px">
            <el-option v-for="item in hasRelate" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关联专业:">
          <el-select clearable v-model="formInline.hasRelateZy" placeholder="不限" size="small"
                     style="width: 80px; margin-right: 20px">
            <el-option v-for="item in hasRelate" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否专业组:">
          <el-select clearable v-model="formInline.isOptions" @change="changeOptions" placeholder="请选择" size="small"
                     style="width: 80px; margin-right: 20px">
            <el-option v-for="item in optionsgl" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="高校省份:">
          <el-select clearable v-model="formInline.collegeProvince" placeholder="不限" size="small"
                     style="width: 100px; margin-right: 20px" value-key="id">
            <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="院校特性">
          <el-select clearable multiple v-model="collegeCharacter" placeholder="不限" @change="changecollegeCharacter"
                     size="small" style="width: 200px; margin-right: 20px">
            <el-option v-for="item in collegeCharacteroptions" :key="item.value" :label="item.label"
                       :value="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="院校：">
          <el-input v-model="formInline.college" placeholder="请输入高校名称或代码" size="small"
                    style="width: 180px; margin-right: 20px" clearable></el-input>
        </el-form-item>
        <el-form-item label="专业：">
          <el-input v-model="formInline.specialty" placeholder="请输入专业名称或代码" size="small"
                    style="width: 180px; margin-right: 20px" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="pageplan">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="topright">
      <div style="padding-top: 4px">
        <span style="color: #666666; font-size: 14px; margin-right: 5px">显示更多信息</span>
        <el-switch
            v-model="showMore"
            active-color="#1ab394"
            inactive-color="#999999"
            style="margin-right: 10px"></el-switch>
      </div>
      <el-button size="small" type="danger" @click="delets" v-permission="'900502'">删除</el-button>
      <el-button type="primary" size="small" @click="cdkeyExport" v-permission="'900501'">导出</el-button>
      <!--      <el-button type="primary" size="small" @click="exportTempData" v-permission="'900501'">临时导出</el-button>-->
      <el-upload class="upload1" action="/com/had-login/admission/admission-plan/importExcel" :headers="uploadheaders"
                 accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                 :show-file-list="false" :on-progress="uploading" :on-success="importSuccess" v-permission="'900501'">
        <el-button type="primary" size="small">导入</el-button>
      </el-upload>
      <el-button type="primary" size="small" style="margin-left: 10px" v-permission="'900501'">
        <a :href="`${path}excel/zsjh.xlsx`" download="专业招生计划模板.xlsx" style="color: #fff">下载模板</a>
      </el-button>
    </div>
    <div class="table">
      <el-table :stripe="true" size="mini" :height="tableHeigth" :data="tableData" border style="width: 100%"
                :header-cell-style="{ 'text-align': 'center', 'font-size': '14px', 'padding': '0px' }"
                :cell-style="cellStyle"
                @selection-change="handleSelectionChange"
                @cell-click="cellClick">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="collegeCode" label="院校代码" width="80">
        </el-table-column>
        <el-table-column label="院校名称" min-width="160">
          <template slot-scope="scope">
            <div class="maxlength">
              {{ scope.row.collegeName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="specialtyOptions" label="专业组" min-width="140" v-if="formInline.isOptions === 1">
        </el-table-column>
        <el-table-column prop="universityName" label="关联院校" min-width="160">
        </el-table-column>
        <el-table-column prop="specialtyCode" label="专业代码" width="80">
        </el-table-column>
        <el-table-column prop="specialtyName" label="专业名称" width="200" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="majorName" label="关联专业" width="140" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="选考科目要求" width="150" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ matchRequiredType(scope.row.requiredType) }}</span>
            <span v-if="scope.row.requiredType !== 0">{{ scope.row.requiredDiscipline }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="year" label="年份" width="60"></el-table-column>
        <el-table-column prop="province" label="省|直辖市" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="科别类型" width="80">
          <template slot-scope="scope">
            <div v-if="scope.row.disciplineType === 4">历史类</div>
            <div v-if="scope.row.disciplineType === 3">物理类</div>
            <div v-if="scope.row.disciplineType === 2">文科</div>
            <div v-if="scope.row.disciplineType === 1">理科</div>
            <div v-if="scope.row.disciplineType === 0">不分文理</div>
          </template>
        </el-table-column>
        <el-table-column prop="admitBatch" label="录取批次" width="150"></el-table-column>
        <el-table-column prop="planNum" label="招生人数" width="80"></el-table-column>
        <el-table-column prop="currentYearLowestScore" :label="currentYear + '年最低分'" width="80" v-if="showMore"></el-table-column>
        <el-table-column prop="currentYearLowestRanking" :label="currentYear + '年最低位次'" width="80" v-if="showMore"></el-table-column>
        <el-table-column prop="currentYearPlanNum" :label="currentYear + '年计划人数'" width="80" v-if="showMore"></el-table-column>
        <el-table-column prop="lastYearLowestScore" :label="(currentYear - 1) + '年最低分'" width="80" v-if="showMore"></el-table-column>
        <el-table-column prop="lastYearLowestRanking" :label="(currentYear - 1) + '年最低位次'" width="80" v-if="showMore"></el-table-column>
        <el-table-column prop="lastYearPlanNum" :label="(currentYear - 1) + '年计划人数'" width="80" v-if="showMore"></el-table-column>
        <el-table-column prop="beforeYearLowestScore" :label="(currentYear - 2) + '年最低分'" width="80" v-if="showMore"></el-table-column>
        <el-table-column prop="beforeYearLowestRanking" :label="(currentYear - 2) + '年最低位次'" width="80" v-if="showMore"></el-table-column>
        <el-table-column prop="beforeYearPlanNum" :label="(currentYear - 2) + '年计划人数'" width="80" v-if="showMore"></el-table-column>
        <el-table-column label="所在城市" width="100" v-if="showMore" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.collegeProvince">{{scope.row.collegeProvince}}</span>
            <span v-if="scope.row.collegeCity">{{scope.row.collegeCity}}</span>
          </template>
        </el-table-column>
        <el-table-column label="院校标签" width="100" v-if="showMore" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{scope.row.collegeTag ? scope.row.collegeTag : '/'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="院校性质" width="80" v-if="showMore" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{scope.row.collegeCharacter ? scope.row.collegeCharacter : '/'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="postgraduateAdmissionRate" label="保研率" width="80" v-if="showMore"></el-table-column>
        <el-table-column prop="masterSpecialtyNum" label="硕士专业数" width="100" v-if="showMore"></el-table-column>
        <el-table-column prop="doctorSpecialtyNum" label="博士专业数" width="100" v-if="showMore"></el-table-column>
        <el-table-column prop="softScienceRanking" label="软科排名" width="80" v-if="showMore"></el-table-column>
        <el-table-column label="学科评估" width="120" v-if="showMore" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{scope.row.academicAssessment ? scope.row.academicAssessment : '/'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="专业硕士点" width="120" v-if="showMore" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{scope.row.masterSpecialty ? scope.row.masterSpecialty : '/'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="专业博士点" width="120" v-if="showMore" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{scope.row.doctorSpecialty ? scope.row.doctorSpecialty : '/'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="60">
          <template slot-scope="scope" v-if="scope.row.admissionPlanId">
            <el-button type="text" @click="del(scope.row.admissionPlanId)" style="color: #f56c6c; font-size: 14px"
                       v-permission="'900502'">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <div style="font-size: 14px; color: #333333; padding-left: 10px">
        当前为第{{ formInline.current }}页/ 总共{{ totalPages }}页，总记录数为{{
          total
        }}条
      </div>

      <el-pagination background @current-change="handleChange" :current-page.sync="formInline.current"
                     :page-size="formInline.size" layout="prev, pager, next" :total="total">
      </el-pagination>
    </div>
    <!-- 多数据操作 -->
    <el-dialog title="请选择操作数据操作" :visible.sync="centerDialogVisible" width="400px" center>
      <div class="centerdiv">
        <el-radio v-model="radio" :label="1">当前勾选数据</el-radio>
        <el-radio v-model="radio" :label="2">当前条件数据</el-radio>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="chooseset" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "@/util/request";
import lpyMixin from "@/mixin/lpyMixin";
import {getProvinceList} from "@/api/index.js";
import {deleteBatchplan, deletesplan, pageplan,} from "@/api/collegeEntranceExamination.js";
import {getOneProvince} from "@/api/systemManagement.js";

export default {
  mixins: [lpyMixin],
  data() {
    return {
      cellStyle: {
        "text-align": "center",
        "font-size": "14px",
        visibility: "hidden",
      },
      radio: 1,
      total: 0,
      totalPages: 1,
      centerDialogVisible: false,
      uploadheaders: {
        sessionId: sessionStorage.getItem("sessionId") || "",
      },
      hasRelate: [
        {label: "未关联", value: 0},
        {label: "已关联", value: 1},
      ],
      options1: [
        {label: "不分文理", value: 0},
        {label: "理科", value: 1},
        {label: "文科", value: 2},
        {label: "物理类", value: 3},
        {label: "历史类", value: 4},
      ], //科别
      optionsgl: [
        {label: "是", value: 1},
        {label: "否", value: 0},
      ],
      disabled: true,
      loading: false,
      path: process.env.BASE_URL,
      batchoptions: [],
      formInline: {
        size: 500,
        current: 1,
        province: {},
        isOptions: 0,
        collegeProvince: {id: "", name: ""},
        disciplineType: null,
        admitBatch: "",
        checkPermission: 1
      },
      tableData: [],
      input: "",
      options: [],
      id: "",
      // provinceobj: {},
      yearoptions: [],
      ids: [],
      lastDisciplineType: 0,
      lastBatch: "",
      collegeCharacteroptions: [
        {label: "211", value: "1"},
        {label: "985", value: "2"},
        {label: "双一流", value: "3"},
        {label: "国重点", value: "4"},
        {label: "省重点", value: "5"},
        {label: "保研资格", value: "6"}
      ],
      collegeCharacter: [],
      showMore: false,
      currentYear: new Date().getFullYear()
    };
  },
  mounted() {
    for (var i = 0; i < 500; i++) {
      this.tableData.push({});
    }
    // this.pageplan()
    this.getProvinceList();
    this.getyearsoptions();
  },
  methods: {
    matchRequiredType(requiredType) {
      switch (requiredType) {
        case 0:
          return "不提科目要求";
        case 1:
          return "任选一门报考：";
        case 2:
          return "均报考：";
      }
    },
    changecollegeCharacter(val) {
      this.formInline.collegeCharacter = val.join(",");
    },
    changeOptions() {
      this.pageplan();
    },

    cellClick(row, column, cell, event){
      if (column.label === "专业名称"){
        this.$alert(row.specialtyName, '专业名称', {
          confirmButtonText: '确定'
        });
      }
    },

    handleSelectionChange(val) {
      this.ids = [];
      val.forEach((item) => {
        if (item.admissionPlanId) {
          this.ids.push(item.admissionPlanId);
        }
      });
      if (val.length === this.ids.length && val.length > 0) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
    chooseset() {
      if (this.radio === 1) {
        if (this.ids.length === 0) {
          this.$message.error("当前无勾选数据");
        } else {
          this.$confirm(
              "确定要删除当前勾选的共" + this.ids.length + "条数据吗",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
          )
              .then(() => {
                deleteBatchplan({idList: this.ids, type: 1}).then((res) => {
                  if (res.code === 1) {
                    this.pageplan();
                    this.$message({
                      message: "删除成功",
                      type: "success",
                    });
                    this.centerDialogVisible = false;
                  }
                });
              })
              .catch(() => {
              });
        }
      }

      if (this.radio === 2) {
        let deletePramas = {...this.formInline};
        deletePramas.type = 2;
        this.formInline.size = 1;
        pageplan(this.formInline).then((res) => {
          if (res.code === 1) {
            this.formInline.size = 500;
            let totalCount = res.data.total;
            this.$confirm(
                "确定要删除当前条件下共" + totalCount + "条数据吗",
                "提示",
                {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                }
            )
                .then(() => {
                  deleteBatchplan(deletePramas).then((res) => {
                    if (res.code === 1) {
                      this.pageplan();
                      this.$message({
                        message: "删除成功",
                        type: "success",
                      });
                      this.centerDialogVisible = false;
                    }
                  });
                })
                .catch(() => {
                });
          }
        });
      }
    },
    //批量删除
    delets() {
      this.centerDialogVisible = true;
    },
    //获取录取批次
    handelchange() {
      this.formInline.disciplineType = null;
      this.formInline.admitBatch = null;
      this.formInline = {...this.formInline};
      this.batchoptions = [];
      if (this.formInline.year && this.formInline.province.id) {
        // getProvincePage({
        //   year: this.formInline.year,
        //   areaProvinceId: this.formInline.province.id,
        // }).then((res) => {
        //   console.log(res, "res");
        //   let data = res.data || {};
        //   let arr = data.records || [];
        //   this.batchoptions = arr[0].batchs || [];
        // });
        getOneProvince({
          year: this.formInline.year,
          areaProvinceId: this.formInline.province.id,
        }).then((res) => {
          if (res.code === 1) {
            let data = res.data;
            this.batchoptions = data.batchs || [];
            if (data.pattern === 3) {
              this.options1 = [
                {label: "理科", value: 1},
                {label: "文科", value: 2},
              ];
            }
            if (data.pattern === 2) {
              this.options1 = [
                {label: "物理类", value: 3},
                {label: "历史类", value: 4},
              ];
            }
            if (data.pattern === 1) {
              this.options1 = [{label: "不分文理", value: 0}];
            }
          }
          //判断上次科别类型和批次是否存在
          this.options1.forEach((item) => {
            if (item.value === this.lastDisciplineType) {
              this.formInline.disciplineType = item.value;
            }
          });

          this.batchoptions.forEach((item) => {
            if (item.batch === this.lastBatch) {
              this.formInline.admitBatch = item.batch;
            }
          });
        });
      } else {
        this.options1 = [
          {label: "不分文理", value: 0},
          {label: "理科", value: 1},
          {label: "文科", value: 2},
          {label: "物理类", value: 3},
          {label: "历史类", value: 4},
        ];
      }
    },
    disciplineTypeChange(value) {
      this.lastDisciplineType = value;
    },

    batchChange(value) {
      this.lastBatch = value;
    },
    // 跳页
    handleChange(page) {
      console.log(page);
      this.formInline.current = page;
      this.pageplan();
    },
    //获取列表
    pageplan() {
      this.formInline.province = this.formInline.province || {};
      if (!this.formInline.collegeProvince) {
        this.formInline.collegeProvince = null;
      }
      pageplan(this.formInline).then((res) => {
        if (res.code === 1) {
          this.cellStyle.visibility = "visible";
          let data = res.data || {};
          this.tableData = data.records || [];
          if (this.tableData.length > 0 && this.tableData[0].currentYear) {
            this.currentYear = this.tableData[0].currentYear
          }
          this.total = data.total || 0;
          this.totalPages = data.pages;
        }
      });
    },
    uploading() {
      this.loading = true;
    },

    // 导出
    exportTempData() {
      axios({
        method: "get",
        url: "/com/had-login/admission/admission-plan/exportTempData",
        params: {
          disciplineType: 4
        },
        responseType: "blob",
      })
          .then((res) => {
            const elink = document.createElement("a");
            elink.download = "招生计划列表.xls"; //定义表格名称，后缀是文件格式
            elink.style.display = "none";
            const blob = new Blob([res], {
              type: "application/vnd.ms-excel",
            });
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            document.body.removeChild(elink);
          })
          .catch((err) => {
            console.log(err);
          });
    },

    // 导出
    cdkeyExport() {
      let data = this.formInline;
      axios({
        method: "post",
        url: "/com/had-login/admission/admission-plan/exportExcel",
        data: data,
        responseType: "blob",
      })
          .then((res) => {
            const elink = document.createElement("a");
            elink.download = "招生计划列表.xls"; //定义表格名称，后缀是文件格式
            elink.style.display = "none";
            const blob = new Blob([res], {
              type: "application/vnd.ms-excel",
            });
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            document.body.removeChild(elink);
          })
          .catch((err) => {
            console.log(err);
          });
    },
    importSuccess(res) {
      this.loading = false;
      if (res.code === 1) {
        this.$message.success("导入成功")
      } else {
        this.open(res.msg);
      }
    },
    open(data) {
      this.$alert(data, "错误", {
        confirmButtonText: "确定",
        callback: (action) => {
        },
      });
    },
    //获取省份
    getProvinceList() {
      getProvinceList().then((res) => {
        this.options = res.data;
      });
    },
    //获取年份
    getyearsoptions() {
      let date = new Date();
      let year = date.getFullYear();
      this.formInline.year = year;
      this.formInline = {...this.formInline};
      for (let i = -2; i < 10; i++) {
        this.yearoptions.push({label: year - i, value: year - i});
      }
    },
    del(id) {
      this.id = id;

      this.$confirm("是否删除此条招生计划？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            this.deletesplan();
          })
          .catch(() => {
          });
    },
    deletesplan() {
      deletesplan({admissionPlanIds: this.id}).then((res) => {
        if (res.code === 1) {
          this.pageplan();
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.bigbox {
  padding: 20px 20px 0px;

  /deep/ .el-form-item {
    margin-bottom: 12px !important;
  }

  /deep/ .upload1 {
    display: inline-block;
    margin-left: 10px;
  }

  .topright {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
  }

  /deep/ .maxlength {
    display: -webkit-box !important;

    -webkit-box-orient: vertical !important;

    -webkit-line-clamp: 2 !important;
    overflow: hidden !important;
    font-size: 14px !important;
  }

  .table {
    position: relative;

    .mask {
      position: absolute;
      width: 100%;
      height: 563px;
      top: 37px;
      left: 0px;
      background-color: rgba(255, 255, 255, 1);
      z-index: 99999999;
    }
  }

  .button {
    position: absolute;
    top: -56px;
    right: 0px;
  }

  .pagination {
    display: flex;
    justify-content: space-between;
    padding-top: 10px;
  }
}
</style>
